module.exports = __webpack_public_path__ + "media/images/flags/4x3/sgs-62046d1aacc0f42a441abb954ac81f9c.svg";